(function () {
  const KONFIG_ID = 'reparatur-konfigurator';

  function getHeaderOffset() {
    const header = document.querySelector('sticky-header, .header-wrapper');
    return header ? header.getBoundingClientRect().height + 16 : 100;
  }

  function scrollToKonfigurator() {
    const el = document.getElementById(KONFIG_ID);
    if (!el) return false;

    const top = el.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    if (window.location.hash !== `#${KONFIG_ID}`) {
      history.replaceState(null, '', `#${KONFIG_ID}`);
    }
    return true;
  }

  function onKonfigLinkClick(event) {
    const href = event.currentTarget.getAttribute('href') || '';
    if (!href.includes(KONFIG_ID)) return;

    if (document.getElementById(KONFIG_ID)) {
      event.preventDefault();
      scrollToKonfigurator();
    }
  }

  function init() {
    document.querySelectorAll(`a[href*="${KONFIG_ID}"]`).forEach((link) => {
      link.removeEventListener('click', onKonfigLinkClick);
      link.addEventListener('click', onKonfigLinkClick);
    });

    document.querySelectorAll('a.button, a.kc-btn').forEach((link) => {
      const label = (link.textContent || '').trim();
      if (label.includes('Reparatur online buchen') && document.getElementById(KONFIG_ID)) {
        link.setAttribute('href', `#${KONFIG_ID}`);
        link.removeAttribute('aria-disabled');
        link.removeAttribute('role');
        link.removeEventListener('click', onKonfigLinkClick);
        link.addEventListener('click', onKonfigLinkClick);
      }
    });

    if (window.location.hash === `#${KONFIG_ID}`) {
      setTimeout(scrollToKonfigurator, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
